import Api from "@/inc/Api";

export const getClassList = async () => {
    // Simulate an API call to fetch class data
    let api = Api;
    api.setUserToken();
    const response = await api.axios().get('/academy-class/list?all=yes');
    return response.data.type ? response.data.data.academy_class : [];
}